import { useMutation } from "react-query";
import { addCodeLevel } from "../../../../../actions/Utilities/CodeLevel";

const useAddCodeLevel = () => {
  return useMutation(addCodeLevel);
};
export default useAddCodeLevel;
